var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScratchCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.625 130.5H33.375C28.2 130.5 24 126.3 24 121.125V28.875C24 23.7 28.2 19.5 33.375 19.5H116.625C121.8 19.5 126 23.7 126 28.875V121.125C126 126.3 121.8 130.5 116.625 130.5Z",
    fill: "#FE8470"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63 118.5C61.44 118.5 59.91 118.02 58.635 117.09C56.88 115.83 55.755 113.88 55.545 111.735C54.345 99.69 65.895 88.785 79.305 76.17C78.09 76.86 76.86 77.565 75.63 78.285C67.14 83.175 58.365 88.245 47.79 92.46C45.33 93.435 42.54 93.045 40.455 91.44C38.37 89.835 37.26 87.24 37.575 84.615C39.6 67.245 49.59 58.275 59.49 51C55.545 52.86 51.81 55.275 48.375 58.215C45.225 60.9 40.5 60.54 37.8 57.39C35.115 54.24 35.49 49.5 38.625 46.815C51.885 35.49 68.28 30.21 86.055 31.545C88.86 31.755 91.305 33.51 92.4 36.105C93.495 38.685 93.06 41.67 91.26 43.83C85.26 51.03 78.255 56.025 72.075 60.435C67.545 63.675 63.555 66.51 60.36 69.75C63 68.28 65.58 66.795 68.13 65.325C79.35 58.86 90.96 52.17 105.255 48.765C108.09 48.09 111.06 49.125 112.86 51.405C114.66 53.685 114.99 56.82 113.685 59.415C108.93 68.925 99.165 78.105 89.715 86.985C86.19 90.285 81.87 94.35 78.21 98.265C89.265 93.675 98.595 87.765 106.83 82.275C110.28 79.98 114.93 80.91 117.225 84.36C119.52 87.81 118.59 92.46 115.14 94.755C101.91 103.575 86.01 113.4 64.665 118.32C64.125 118.44 63.57 118.5 63 118.5Z",
    fill: "#FFCEC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScratchCard);
export default __webpack_public_path__ + "static/media/ScratchCard.e8fc6a6296239ea8932f87cb4ac9780b.svg";
export { ForwardRef as ReactComponent };